module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_robot_8b2241047e50dc79495633cb2851d575.png";